import SemiProductService from "services/SemiProductService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import openNotification from "utils/notification";
import Utils from "utils";

export const semiProductSearchGrid = createAsyncThunk(
  "semi-product/semiProductSearchGrid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SemiProductService.semiProductSearchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getSemiProductById = createAsyncThunk(
  "semi-product/getSemiProductById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await SemiProductService.getSemiProductById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addSemiProductApi = createAsyncThunk(
  "semi-product/addSemiProductApi",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SemiProductService.addSemiProductApi(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateSemiProductApi = createAsyncThunk(
  "semi-product/updateSemiProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SemiProductService.updateSemiProductApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delSemiProductApi = createAsyncThunk(
  "semi-product/delSemiProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SemiProductService.delSemiProductApi(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const syncSemiProductApi = createAsyncThunk(
  "semi-product/syncSemiProductApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SemiProductService.syncSemiProductApi(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const syncSemiProductV2Api = createAsyncThunk(
  "semi-product/syncSemiProductV2Api",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SemiProductService.syncSemiProductV2Api(data);
      if (onSuccess) onSuccess(response);
      // openNotification(
      //   "success",
      //   Utils.setLocale("admin.settings.popup.notification.success"),
      //   Utils.setLocale("admin.settings.popup.notification.title"),
      // );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  syncLoading: false,
  semiProductList: [],
  semiProductDetail: {},
  totalCount: 0,
};

const semiProductSlice = createSlice({
  name: "semi-product",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(semiProductSearchGrid.pending, (state) => {
        state.loading = true;
      })
      .addCase(semiProductSearchGrid.fulfilled, (state, action) => {
        state.loading = false;
        state.semiProductList = action.payload;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(semiProductSearchGrid.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getSemiProductById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSemiProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.semiProductDetail = action.payload;
      })
      .addCase(getSemiProductById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addSemiProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSemiProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addSemiProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateSemiProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSemiProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateSemiProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(delSemiProductApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delSemiProductApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delSemiProductApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(syncSemiProductApi.pending, (state) => {
        state.syncLoading = true;
      })
      .addCase(syncSemiProductApi.fulfilled, (state, action) => {
        state.syncLoading = false;
      })
      .addCase(syncSemiProductApi.rejected, (state, action) => {
        state.syncLoading = false;
      })
      .addCase(syncSemiProductV2Api.pending, (state) => {
        state.syncLoading = true;
      })
      .addCase(syncSemiProductV2Api.fulfilled, (state, action) => {
        state.syncLoading = false;
      })
      .addCase(syncSemiProductV2Api.rejected, (state, action) => {
        state.syncLoading = false;
      });
  },
});

export const { showLoading } = semiProductSlice.actions;

export default semiProductSlice.reducer;
